import { LoadingAnimState } from './loading-anim.reducer';

export interface State {
    loadAnim: LoadingAnimState;
}

export const getShow = state => state.show;
